

import { Component, Vue, Prop } from 'nuxt-property-decorator';
import RouterLink from '~/components/atoms/text/RouterLink.vue';
import { Products } from '~/operations/messages';

@Component({
  components: {
    RouterLink,
  }
})
export default class PeilstabBannerOrganism extends Vue {
  @Prop({ default: 'Der esyoil-Newsletter' }) title: string;

  Products = Products;
}

